import type { ReactElement } from "react";
import { Knopf, Pillenreihe } from "@kundeninfo/ui/me-design";
import { DUE_SOURCES } from "./dueItems.js";
import type { DueSource } from "./dueItems.js";
import { DUE_ITEM_TEXT } from "./dueItemTexts.js";
import { DUE_SYMBOL_PATHS, DUE_SYMBOLS } from "./dueSymbols.js";
import "./Termine.css";

/** Das Symbol einer Quelle im 16er-Raster (Übergang T-15); stumm, den Namen trägt das Wort daneben. */
export function DueSymbol(p: { source: DueSource }): ReactElement {
  return (
    <svg className="ter__symbol" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d={DUE_SYMBOL_PATHS[p.source]} />
    </svg>
  );
}

/**
 * DIE QUELLEN-CHIPS (Spec D22, Plan T17): je angebotene Quelle ein Umschalt-Chip — me-design legt fest „Umschalt-Chips
 * sind `Knopf gestalt="pille" gedrueckt`, kein Chip“ (Rahmen = anklickbar, gedrückt getönt). Symbol und Wort in den
 * Maßen der Chip-Tokens (670), in einer eigenen Zeile `.ter__sources` unter der Werkzeugleiste (Muster `.tl__zeitraum`,
 * Ruling 548), die am Telefon umbricht.
 * `value` ist die ganze Wahl: Ein Klick schaltet eine Quelle und meldet die neue Wahl in der Quellenfolge — Quellen, die
 * hier nicht stehen (in der Liste „Tickets“), bleiben darin.
 */
export function DueSourceChips(p: { sources: readonly DueSource[]; value: readonly DueSource[];
                                    onChange: (v: DueSource[]) => void }): ReactElement {
  const toggle = (s: DueSource) =>
    p.onChange(DUE_SOURCES.filter((d) => (d === s ? !p.value.includes(d) : p.value.includes(d))));
  return (
    <div className="ter__sources" role="group" aria-label={DUE_ITEM_TEXT.chipsName}>
      <span className="ter__sources-label" aria-hidden="true">{DUE_ITEM_TEXT.chipsName}</span>
      <Pillenreihe className="ter__chips">
        {p.sources.map((s) => (
          <Knopf key={s} art="sekundaer" gestalt="pille" gedrueckt={p.value.includes(s)} symbol={DUE_SYMBOLS[s]}
            onClick={() => toggle(s)}>
            <DueSymbol source={s} />{DUE_ITEM_TEXT.chipLabel[s]}
          </Knopf>
        ))}
      </Pillenreihe>
    </div>
  );
}
